export const PACKAGING_CATEGORY_SOURCE = 'catalogTaxonomy'

/**
 * @param {{
 *   node: { id: string, name?: string },
 *   pathLabel: string,
 *   pathIds?: string[],
 * }} args
 */
export const createPackagingCategorySelection = ({ node, pathLabel, pathIds = [] }) => ({
  source: PACKAGING_CATEGORY_SOURCE,
  catalogTaxonomyNodeId: node.id,
  catalogTaxonomyNodeName: node.name || '',
  pathLabel,
  pathIds,
})

export const getPackagingCategoryPathLabel = (selection) => {
  if (!selection) {
    return ''
  }

  return selection.pathLabel || selection.related_category_path_label || ''
}

export const getPackagingCategoryNodeId = (selection) => {
  if (!selection) {
    return null
  }

  return selection.catalogTaxonomyNodeId || null
}
